module.exports = __webpack_public_path__ + "img/25.df0d035b.jpg";